/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// material
import Copy from 'material/copy/copy';
import BodyCopy from 'material/copy/bodycopy/bodycopy';
import CTAs from 'material/ctas/ctas';
import Button from 'material/ctas/button/button_container';
import Illustration from 'material/graphic/illustration/illustration';
// styles
import injectSheet from 'react-jss';
import styles from 'material/states/empty/empty_styles';



/* ========== ~~~~~~~~~~ STATES : EMPTY : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const EmptyState = (props) => {
    return(
        <div className={`emptystate ${props.classes.emptystate} ${props.klass}`}>
            <Illustration name={props.graphicName} text={props.graphicText} />
            <Copy>
                <BodyCopy>
                    <p>{props.bodycopy}</p>
                </BodyCopy>
            </Copy>
            <CTAs>
                {!!props.buttonClick ? <Button type={`custom`} handleClick={props.buttonClick} variant={`primary`} name={props.buttonName} text={props.buttonText} /> : null}
            </CTAs>
        </div>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(EmptyState);
